module.exports = __webpack_public_path__ + "img/select-entries-per-page.a888b035.png";